import { render, staticRenderFns } from "./PainelDeControle.vue?vue&type=template&id=6ff8ebc9&scoped=true&"
import script from "./PainelDeControle.vue?vue&type=script&lang=js&"
export * from "./PainelDeControle.vue?vue&type=script&lang=js&"
import style0 from "./PainelDeControle.vue?vue&type=style&index=0&id=6ff8ebc9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff8ebc9",
  null
  
)

export default component.exports